export enum UserTosStatus {
  LOADING = 'loading',
  NOT_ACCEPTED = 'not accepted',
  OUTDATED = 'outdated',
  ACCEPTED = 'accepted',
}
